export default [
  {
    title: 'Category',
    hidden: false
  },
  {
    title: 'Debug',
    hidden: true
  },
  {
    title: 'Hidden',
    key: 'hidden',
    hidden: true
  },
  {
    title: 'Reserved Instance ID',
    key: 'ReservedInstancesId',
    hidden: false
  },
  {
    title: 'Currency Code',
    key: 'CurrencyCode',
    hidden: false
  },
  {
    title: 'Region',
    key: 'region',
    hidden: false
  },
  {
    title: 'Account ID',
    key: 'accountId',
    hidden: false
  },
  {
    title: 'Account Name',
    key: 'accountName',
    hidden: false
  },
  {
    title: 'Instance Type',
    key: 'InstanceType',
    hidden: false
  },
  {
    title: 'State',
    key: 'State',
    hidden: false
  },
  {
    title: 'Duration',
    key: 'Duration',
    hidden: false
  },
  {
    title: 'End',
    key: 'End',
    hidden: false
  },
  {
    title: 'FixedPrice',
    key: 'FixedPrice',
    hidden: false
  },
  {
    title: 'InstanceCount',
    key: 'InstanceCount',
    hidden: false
  },
  {
    title: 'InstanceTenancy',
    key: 'InstanceTenancy',
    hidden: false
  },
  {
    title: 'OfferingType',
    key: 'OfferingType',
    hidden: false
  },
  {
    title: 'OfferingClass',
    key: 'OfferingClass',
    hidden: false
  },
  {
    title: 'ProductDescription',
    key: 'ProductDescription',
    hidden: false
  },
  {
    title: 'RecurringCharges',
    key: 'RecurringCharges',
    hidden: false
  },
  {
    title: 'Scope',
    key: 'Scope',
    hidden: false
  },
  {
    title: 'Start',
    key: 'Start',
    hidden: false
  },
  {
    title: 'UsagePrice',
    key: 'UsagePrice',
    hidden: false
  }
];


// WEBPACK FOOTER //
// ./src/components/content/ec2ResExplorer/utils/tableHeaders.js